import { apiClient, Auth } from '@/shared/api'
import { action } from '@/shared/config'

import { ZSendStatementEmailRequest } from './schema'

export const sendStatementEmail = action
  .metadata({
    actionName: 'sendStatementEmailAction',
  })
  .schema(ZSendStatementEmailRequest)
  .action(async ({ parsedInput: { contractId, body } }) => {
    await apiClient.post<null>({
      endpoint: `/guest/contracts/${contractId}/statements/email`,
      body,
      auth: Auth.REQUIRED,
    })
  })
